<template>
<div>
  <div class="properties">
    <property :name="'סוג מנוי'" :value="'תקופת ניסיון'"/>
    <property :name="'סיום תקופת הניסיון'" :value="trialEndDateFormatted"/>
    <div class="promo-notification-box-container">
      <promo-notification-box />
    </div>
  </div>
  <div class="separator"/>
  <div class="subscribe-button-container">
    <riseup-button class="subscribe-button" :action="subscribeClicked"
                   :title="'הרשמה עם כרטיס אשראי'"/>
  </div>
</div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState } from 'vuex';
import dates from '../../../../../utils/dates';
import SubscribeClickHandler from './SubscribeClickHandler.vue';
import Property from './Property.vue';
import PromoNotificationBox from '../../../../../base-components/discount-promotion/PromoNotificationBox.vue';

export default {
  name: 'TrialSettings',
  components: {
    Property,
    RiseupButton: BaseUI.RiseupButton,
    PromoNotificationBox,
  },
  mixins: [SubscribeClickHandler],
  computed: {
    ...mapState('subscriptionState', ['until']),
    trialEndDateFormatted() {
      return dates.longHebrewDateFormat(this.until);
    },
  },
};
</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";
  @import "./settings";

  @include properties;

  .promo-notification-box-container {
    padding: 0 23px;
  }

  .separator {
    height: 1px;
    background-color: $riseup_gray_0;
  }

  .subscribe-button-container {
    display: flex;
    justify-content: center;
    align-items: center;

    .subscribe-button {
      margin: 23px;
      width: 100%;
    }
  }

</style>
